import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "User Research",
    description: "Deep analysis of audience preferences, expectations, and pain points.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Wireframes & Prototypes",
    description: "Interactive prototypes to validate design concepts before development.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 10h16M10 4v16" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Visual Design",
    description: "Stunning color schemes, typography, iconography, and brand-aligned imagery.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5h16v14H4V5Z" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="9" cy="10" r="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 16l5-4 4 3 5-5 4 6" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Cross-Platform UX",
    description: "Excellent user experience across devices, platforms, and screen sizes.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="5" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <rect x="8" y="19" width="8" height="2" rx="1" stroke="currentColor" strokeWidth="1.5" />
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const UiuxIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro" aria-labelledby="uiux-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">UI/UX Design</span>
            <h2 id="uiux-intro-title" className="wdev-intro__title">
              UI/UX Design Agency in Bangalore
            </h2>

            <p className="wdev-intro__text">
              At WebTech, we recognize the importance of intuitive and visually appealing
              user interfaces. Our talented designers and developers collaborate closely with
              clients to create seamless user experiences that captivate and engage audiences.
              With a deep understanding of user behavior and industry trends, we craft designs
              that not only look great but also deliver exceptional usability.
            </p>
            <p className="wdev-intro__text">
              Our UI/UX design process begins with a thorough analysis of your target audience
              and project goals. We conduct extensive research to gain insights into user
              preferences, expectations, and pain points. Based on these findings, we develop
              wireframes and interactive prototypes to validate our design concepts. This
              iterative approach ensures that our final designs are tailored specifically to
              your users&apos; needs and preferences.
            </p>
            <p className="wdev-intro__text">
              WebTech Software Solutions, a top UI/UX design agency in Bangalore, creates
              user-centered designs that help businesses stand out. By understanding user
              behavior, we craft intuitive, visually appealing experiences that drive customer
              satisfaction. Our agile process ensures timely delivery and designs that exceed
              expectations, blending creativity with technical expertise for impactful results.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default UiuxIntroSection;
